// @generated by protoc-gen-es v1.0.0 with parameter "target=js+dts,ts_nocheck=false"
// @generated from file api/renderer/svc_renderer.proto (package com.diagnocat.taskmaster_new, syntax proto3)
/* eslint-disable */

import { proto3 } from "@bufbuild/protobuf";
import { OrganizationFeatureFlag } from "../../model/dto_organization_pb.js";
import { AssetWithDownloadURLs, ReportBundle } from "../../model/dto_common_service_pb.js";
import { Study } from "../../model/dto_study_pb.js";

/**
 * Request for RendererService.RenderDisplayImage: renders a display image and uploads it to S3 via UploadURL
 *
 * @generated from message com.diagnocat.taskmaster_new.RenderDisplayImageReq
 */
export const RenderDisplayImageReq = proto3.makeMessageType(
  "com.diagnocat.taskmaster_new.RenderDisplayImageReq",
  () => [
    { no: 1, name: "IOXRayStudy", kind: "message", T: RenderDisplayImageReq_InputIOXRayStudy, oneof: "Input" },
    { no: 2, name: "Report", kind: "message", T: RenderDisplayImageReq_InputReport, oneof: "Input" },
    { no: 3, name: "RawMeshStudy", kind: "message", T: RenderDisplayImageReq_InputRawMeshStudy, oneof: "Input" },
    { no: 10, name: "OutputWidth", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 11, name: "OutputHeight", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 12, name: "UploadURL", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 100, name: "FeatureFlags", kind: "message", T: OrganizationFeatureFlag, repeated: true },
    { no: 101, name: "IsPrintMode", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
  ],
);

/**
 * @generated from message com.diagnocat.taskmaster_new.RenderDisplayImageReq.InputIOXRayStudy
 */
export const RenderDisplayImageReq_InputIOXRayStudy = proto3.makeMessageType(
  "com.diagnocat.taskmaster_new.RenderDisplayImageReq.InputIOXRayStudy",
  () => [
    { no: 1, name: "Assets", kind: "message", T: AssetWithDownloadURLs, repeated: true },
    { no: 2, name: "Study", kind: "message", T: Study },
  ],
  {localName: "RenderDisplayImageReq_InputIOXRayStudy"},
);

/**
 * @generated from message com.diagnocat.taskmaster_new.RenderDisplayImageReq.InputReport
 */
export const RenderDisplayImageReq_InputReport = proto3.makeMessageType(
  "com.diagnocat.taskmaster_new.RenderDisplayImageReq.InputReport",
  () => [
    { no: 1, name: "Assets", kind: "message", T: AssetWithDownloadURLs, repeated: true },
    { no: 2, name: "Report", kind: "message", T: ReportBundle },
  ],
  {localName: "RenderDisplayImageReq_InputReport"},
);

/**
 * @generated from message com.diagnocat.taskmaster_new.RenderDisplayImageReq.InputRawMeshStudy
 */
export const RenderDisplayImageReq_InputRawMeshStudy = proto3.makeMessageType(
  "com.diagnocat.taskmaster_new.RenderDisplayImageReq.InputRawMeshStudy",
  () => [
    { no: 1, name: "Assets", kind: "message", T: AssetWithDownloadURLs, repeated: true },
    { no: 2, name: "Study", kind: "message", T: Study },
  ],
  {localName: "RenderDisplayImageReq_InputRawMeshStudy"},
);

